import { MarketBannerCustomEvent } from '@market/web-components';
import { Box } from '@squareup/dex-ui-shared-base';
import { useDecision } from '@squareup/dex-ui-shared-feature-detection';
import { MarketBanner } from '@squareup/dex-ui-shared-market';
import {
  isDevelopmentEnvironment,
  isStagingEnvironment,
} from '@squareup/dex-utils-environment';
import { removeApiExplorerMigrationCookie } from '@squareup/dex-utils-shared-api-explorer';
import clsx from 'clsx';
import React, { FC, MouseEventHandler, useCallback, useState } from 'react';

import styles from './migration-opt-out.module.css';

interface Props {}

const ExplorerMigrationOptOut: FC<Props> = () => {
  const [didDismiss, setDidDismiss] = useState(false);

  const onClick = useCallback<MouseEventHandler<HTMLElement>>((e) => {
    e.preventDefault();

    removeApiExplorerMigrationCookie();

    window.location.reload();
  }, []);

  const onDismiss = useCallback((e: MarketBannerCustomEvent<{}>) => {
    // We have to handle dismissal ourselves to prevent a market error with React.
    // If the page changes, React can't handle the fact that the MarketBanner is no longer in the DOM.
    e.preventDefault();
    setDidDismiss(true);
  }, []);

  const {
    decision: { enabled: migrationFlagEnabled },
  } = useDecision('api_explorer_migration_enabled');

  // Only allow this in staging and dev
  if (!isStagingEnvironment() && !isDevelopmentEnvironment()) {
    return null;
  }

  // Don't show the banner if the flag is on
  if (migrationFlagEnabled) {
    return null;
  }

  if (didDismiss) {
    return null;
  }

  return (
    <MarketBanner
      className={clsx(styles['banner'])}
      dismissable
      onMarketBannerDismissed={onDismiss}
    >
      Go back to{' '}
      <Box as="a" onClick={onClick} href="#">
        the old API Explorer experience.
      </Box>
    </MarketBanner>
  );
};

export { ExplorerMigrationOptOut };
